import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Modal } from "react-bootstrap";
import {
  FaSquareFacebook,
  FaSquareWhatsapp,
  FaSquareInstagram,
  FaSquareYoutube,
  FaSquareXTwitter,
} from "react-icons/fa6";
import Logo from "../../assets/images/logo.svg";
import { useSelector } from "react-redux";
import {
  LOGIN_TYPE,
  SUBSCRIPTION_BUY_MODE,
} from "../../assets/constants/constants";
import { Addon, SubscriptionFlags } from "../Login/interface";
import { useState } from "react";
import ConfirmSubscriptionModal from "../Login/Subscription/BuySubscriptionApprovalModal";
import AddOnConfirmationModal from "../Login/Subscription/AddOnConfirmationModal";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Payment from "../Login/StripePayment/StripePaymentForm";
import "./footer.scss";
import { profileCompletionFlags } from "../../assets/interface/primeSharkWebsite_interface";

const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const token = localStorage.getItem("access_token");
  const isLoggedIn = !!(token && token !== "undefined" && token !== "null" && token.trim() !== "");

  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );
  const profile = useSelector((state: any) => state?.items?.profileDetail);
  const storeProfileCompletion: profileCompletionFlags = useSelector(
    (state: any) => state?.items?.profileCompletionFlags,
  );
  let {
    has_investment_profile_completed,
    has_investment_subscription,
    has_want_to_sell_subscription,
    has_want_to_sell_profile_completed,
    has_want_to_grow_subscription,
    has_want_to_grow_profile_completed,
    has_want_to_grow_subs,
    has_active_subscription,
  } = storeProfileCompletion;
  const loginType = activeLoginTypes?.loginType?.toLowerCase();
  const accountType = activeLoginTypes?.account_type?.toLowerCase();

  const basePath =
    loginType && accountType ? `/${loginType}/${accountType}` : "";
  const origin = window.location.origin;

  // const hasSubscription = profile?.user_subscription;
  // const hasWantToGrowAccess = profile?.user_subscription?.has_want_to_grow ?? 0;

  /* -------------------- Local State -------------------- */

  const [showModal, setShowModal] = useState(false);
  const [showAddOnModal, setShowAddOnModal] = useState(false);
  const [subscriptionMode, setSubscriptionMode] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [availableAdons, setAvailableAdons] = useState<Addon[]>([]);
  const [subscriptionPlanUUID, setSubscriptionPlanUUID] = useState("");
  const [conversionRate, setConversionRate] = useState(1);
  const [currencyCode, setCurrencyCode] = useState("");
  const [loader, setLoader] = useState(false);

  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [buySubscriptionDetails, setBuySubscriptionDetails] = useState<any>({
    client_secret: "",
    payment_intent: "",
    trn_id: "",
    trans_amount: "",
    exchange_rate: "",
    currency_code: "",
  });

  /* -------------------- Helpers -------------------- */

  const storeTabDetails = (tab: string) => {
    console.log(tab);

    localStorage.setItem("Tab_Selected", tab);
    localStorage.setItem("view", "gridView");
  };

  /* -------------------- Navigation Handlers -------------------- */

  const handleGlobalConnectNavigation = () => {
    if (!has_active_subscription) {
      setSubscriptionMode(SUBSCRIPTION_BUY_MODE.RENEW);
      setModalMessage("Your subscription expired! Do you want to renew?");
      setShowModal(true);
      return;
    }

    if (has_active_subscription && !has_want_to_grow_subs) {
      setSubscriptionMode(SUBSCRIPTION_BUY_MODE.ADDON);
      getAddOnDetails();
      setShowAddOnModal(true);
      return;
    }

    storeTabDetails("global-connect");
    navigate(`${basePath}/global-connect`);
  };

  const handleSubscriptionConfirm = () => {
    navigate(`${basePath}/subscriptions?mode=${subscriptionMode}`);
  };

  /* -------------------- API Calls -------------------- */

  const getAddOnDetails = () => {
    setLoader(true);
    WebService.getAPI({
      method: "GET",
      action: "membership/addons",
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          setSubscriptionPlanUUID(res.subscription?.plan?.uuid);
          setAvailableAdons(res.available_addons);
          setCurrencyCode(res.currency);
          setConversionRate(res.conversion_rate);
        }
      })
      .catch((err: any) => toast.error(err?.response?.data?.message))
      .finally(() => setLoader(false));
  };

  /* -------------------- JSX -------------------- */

  return (
    <>
      <footer className="main-footer">
        <Container>
          <Row className="gy-4 align-items-center">
            <Col lg={4} md={12}>
              <Link to="/" className="footer-brand">
                <img src={Logo} width={187} height={52} alt="PrimeShark" />
              </Link>
              <p className="footer-desc">
                Empowering investors and ambitious entrepreneurs to connect, collaborate, and scale globally.
              </p>

              <h6 className="footer-heading">Follow Us</h6>
              <div className="social-links-wrap">
                <a
                  href="https://www.facebook.com/primeshark.0/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon-btn facebook"
                  title="Facebook"
                  aria-label="Facebook"
                >
                  <FaSquareFacebook size={18} />
                </a>
                <a
                  href="https://x.com/theprimeshark28"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon-btn twitter"
                  title="X (Twitter)"
                  aria-label="X (Twitter)"
                >
                  <FaSquareXTwitter size={18} />
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon-btn whatsapp"
                  title="WhatsApp"
                  aria-label="WhatsApp"
                >
                  <FaSquareWhatsapp size={18} />
                </a>
                <a
                  href="https://www.instagram.com/primeshark6/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon-btn instagram"
                  title="Instagram"
                  aria-label="Instagram"
                >
                  <FaSquareInstagram size={18} />
                </a>
                <a
                  href="https://www.youtube.com/@primeshark6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon-btn youtube"
                  title="YouTube"
                  aria-label="YouTube"
                >
                  <FaSquareYoutube size={18} />
                </a>
              </div>
            </Col>

            <Col lg={8} md={12}>
              <div className="footer-links-container">
                <h6 className="footer-heading">Quick Links</h6>

                <div className="footer-nav-links">
                  {isLoggedIn && loginType === LOGIN_TYPE.ENTREPRENEUR.toLowerCase() && (
                    <Link
                      to={`${basePath}/investors`}
                      onClick={() => storeTabDetails("Investor")}
                      className="footer-nav-item"
                    >
                      Investors
                    </Link>
                  )}

                  {isLoggedIn && loginType === LOGIN_TYPE.INVESTOR.toLowerCase() && (
                    <>
                      <Link
                        to={`/investor/capital-bridge`}
                        onClick={() => storeTabDetails("capital_bridge")}
                        className="footer-nav-item"
                      >
                        Capital Bridge
                      </Link>
                      <Link
                        to={`/investor/business-exchange`}
                        onClick={() => storeTabDetails("business_exchange")}
                        className="footer-nav-item"
                      >
                        Business Exchange
                      </Link>
                      <Link
                        to={`/investor/chats`}
                        onClick={() => storeTabDetails("Chat")}
                        className="footer-nav-item"
                      >
                        Chats
                      </Link>
                    </>
                  )}

                  {isLoggedIn && loginType === LOGIN_TYPE.ENTREPRENEUR.toLowerCase() && (
                    <>
                      <button
                        className="footer-link-btn footer-nav-item"
                        onClick={handleGlobalConnectNavigation}
                      >
                        Network
                      </button>
                      <Link to={`${basePath}/chats`} className="footer-nav-item">
                        Messages
                      </Link>
                    </>
                  )}

                  <Link
                    to="/contact-support"
                    onClick={() => storeTabDetails("")}
                    className="footer-nav-item"
                  >
                    Contact Support
                  </Link>
                  <a
                    href="https://theprimeshark.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-nav-item"
                  >
                    Privacy Policy
                  </a>
                  <a
                    href="https://theprimeshark.com/terms-of-use/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-nav-item"
                  >
                    Terms & Conditions
                  </a>
                </div>

                <div className="footer-divider" />

                <div className="footer-bottom">
                  <div className="text-rights">
                    © {year} Prime Shark Community. All rights reserved.
                  </div>
                  <div className="footer-badge">
                    Global Business Network
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* ---------- Modals ---------- */}

      <ConfirmSubscriptionModal
        show={showModal}
        message={modalMessage}
        onConfirm={handleSubscriptionConfirm}
        onCancel={() => setShowModal(false)}
      />

      <AddOnConfirmationModal
        loader={loader}
        show={showAddOnModal}
        addon={availableAdons}
        conversionRate={conversionRate}
        currencyCode={currencyCode}
        message="You don’t have this feature in your subscription. Do you want to add it?"
        onConfirm={() => { }}
        onCancel={() => setShowAddOnModal(false)}
      />

      {buySubscriptionDetails.client_secret &&
        buySubscriptionDetails.payment_intent &&
        buySubscriptionDetails.trn_id && (
          <Modal show={showPaymentForm} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>Payment</Modal.Header>
            <Modal.Body>
              <Payment
                {...buySubscriptionDetails}
                onSuccess={() => setShowPaymentForm(false)}
              />
            </Modal.Body>
          </Modal>
        )}
    </>
  );
};

export default Footer;
